<template lang="pug">
    .ui-content__item-page.ui-buttons.ui-item-page
        h2.ui-item-page__title UI Tag

        .ui-block
            .row.mb-30
                .col-lg-4
                    h5.ui-item-page__sub-title Basic usage
                    vue-tag(size="mini") Tag Two
                    vue-tag(type='primary' size="mini") Tag Two
                    vue-tag(type='success' size="mini") Tag Two
                    vue-tag(type='info' size="mini") Tag Three
                    vue-tag(type='warning' size="mini") Tag Four
                    vue-tag(type='danger' size="mini") Tag Five
                .col-lg-4
                    h5.ui-item-page__sub-title Removable Tag
                    vue-tag(v-for='tag in tags', :key='tag.name', closable='', :type='tag.type' size="mini")
                        | {{tag.name}}
                //.col-lg-4
                    h5.ui-item-page__sub-title Edit Dynamically
                    el-tag(:key='tag', v-for='tag in dynamicTags', closable='', :disable-transitions='false', @close='handleClose(tag)')
                        | {{tag}}
                    el-input.input-new-tag(v-if='inputVisible', v-model='inputValue', ref='saveTagInput', size='mini', @keyup.enter.native='handleInputConfirm', @blur='handleInputConfirm')
                    el-button.button-new-tag(v-else='', size='small', @click='showInput') + New Tag
            .row.mb-30
                .col-lg-3
                    h5.ui-item-page__sub-title Tag with Icon
                    vue-tag(icon="fa fa-clock-o" size="mini") Info
                    vue-tag(icon="fa fa-check" type="nmo" size="mini") HMO
                .col-lg-3
                    h5.ui-item-page__sub-title Sizes
                    vue-tag Default
                    vue-tag(size='medium') Medium
                    vue-tag(size='small') Small
                    vue-tag(size='mini') Mini
</template>
<script>
    import vueTag from '../../components/tag/tag.vue'
    export default {
        data() {
            return {
                dynamicTags: ['Tag 1', 'Tag 2', 'Tag 3'],
                inputVisible: false,
                inputValue: '',
                tags: [
                    { name: 'Tag 1', type: '' },
                    { name: 'Tag 2', type: 'success' },
                    { name: 'Tag 3', type: 'info' },
                    { name: 'Tag 4', type: 'warning' },
                    { name: 'Tag 5', type: 'danger' }
                ]
            };
        },
        methods: {
            handleClose(tag) {
                this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },

            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.dynamicTags.push(inputValue);
                }
                this.inputVisible = false;
                this.inputValue = '';
            }
        },
        components: {
            vueTag
        }
    }
</script>